module.exports = __webpack_public_path__ + "img/caloric_restriction_signaling.a630450b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caloric_restriction_signaling.jpg
// module id = oVRU
// module chunks = 0